import angular from 'angular';
import About from './about/about';
import Login from './login/login';
import Dashboard from './dashboard/dashboard';
import DataBrowser from './dataBrowser/dataBrowser';
import UserInfoPanel from './userInfoPanel/userInfoPanel';
import TableComponent from './tableComponent/tableComponent';
import TableGrid from './tableGrid/tableGrid';
import TableGridRow from './tableGridRow/tableGridRow';
import TableGridTextCell from './tableGridTextCell/tableGridTextCell';
import TableGridCheckboxCell from './tableGridCheckboxCell/tableGridCheckboxCell';
import TableGridIconCell from './tableGridIconCell/tableGridIconCell';
import TableGridValidationCell from './tableGridValidationCell/tableGridValidationCell';
import TableGridRemoveCell from './tableGridRemoveCell/tableGridRemoveCell';
import TableGridDropdownCell from './tableGridDropdownCell/tableGridDropdownCell';
import TableSearch from './tableSearch/tableSearch';
import StatusIndicator from './statusIndicator/statusIndicator';
import PaginationBar from './paginationBar/paginationBar';
import UserAccount from './userAccount/userAccount';
import SecureFileUploader from './secureFileUploader/secureFileUploader';
import SyncSettings from './syncSettings/syncSettings';
import Entitler from './entitler/entitler';
import Assignments from './assignments/assignments';
import AssignmentsUnassigned from './assignmentsUnassigned/assignmentsUnassigned';
import ProductsSelector from './productsSelector/productsSelector';
import SyncSchedule from './syncSchedule/syncSchedule';
import EditCustomer from './editCustomers/editCustomers';
import EditCustomerSection from './editCustomerSection/editCustomerSection';
import ConfigureCustomer from './configureCustomer/configureCustomer';
import AddAdministrator from './addAdministrators/addAdministrators';
import AgentDownloadLink from './agentDownloadLink/agentDownloadLink';
import RequestPasswordReset from './requestPasswordReset/requestPasswordReset';
import PasswordReset from './passwordReset/passwordReset';
import ErrorReport from './errorReport/errorReport';
import DeactivateCustomerAdmin from './deactivateCustomerAdmin/deactivateCustomerAdmin';
import SubmitSuccess from './submitSuccess/submitSuccess';
import SecureAeriesConnection from './secureAeriesConnection/secureAeriesConnection';
import TableGridRadioCell from './tableGridRadioCell/tableGridRadioCell';
import CreateCustomer from './createCustomer/createCustomer';
import Onboarding from './onboarding/onboarding';
import RunExport from './runExport/runExport';
import AssignmentConfirmation from './assignmentConfirmation/assignmentConfirmation';
import SecureOneRosterApiConnection from './secureOneRosterApiConnection/secureOneRosterApiConnection';
import UploadHistory from './uploadHistory/uploadHistory';
import TableGridAccordionToggleCell from './tableGridAccordionToggleCell/tableGridAccordionToggleCell';
import TableGridErrorReportCell from './tableGridErrorReportCell/tableGridErrorReportCell';
import TableGridAccordionRow from './tableGridAccordionRow/tableGridAccordionRow';
import SourceTable from './sourceTable/sourceTable';
import TableGridBody from './tableGridBody/tableGridBody';
import BatchErrors from './batchErrors/batchErrors';
import TableGridModalLinkCell from './tableGridModalLinkCell/tableGridModalLinkCell';
import SourceErrorsModal from './sourceErrorsModal/sourceErrorsModal';
import ProxyingCustomerInfoPanel from './proxyingCustomerInfoPanel/proxyingCustomerInfoPanel';
import SecureFileUploaderStepIndicator from './secureFileUploaderStepIndicator/secureFileUploaderStepIndicator';
import SecureFileUploaderUploadStage from './secureFileUploaderUploadStage/secureFileUploaderUploadStage';
import SecureFileUploaderValidateError from './secureFileUploaderValidateError/secureFileUploaderValidateError';
import SecureFileUploaderCompleteStage from './secureFileUploaderCompleteStage/secureFileUploaderCompleteStage';
import CustomerIntegrationInput from './customerIntegrationInput/customerIntegrationInput';
import RadialProgressBar from './radialProgressBar/radialProgressBar';
import AdminCreateSection from './adminCreateSection/adminCreateSection';
import AddAlertMessage from './addAlertMessage/addAlertMessage';
import AdminToolSection from './adminToolSection/adminToolSection';
import PurchasingAccounts from './purchasingAccounts/purchasingAccounts';
import AdminPermissions from './adminPermissions/adminPermissions';
import uploadSettings from './uploadSettings/uploadSettings';
import batchCancel from './batchCancel/batchCancel';
import TableGridIconExtendedCell from './tableGridIconExtendedCell/tableGridIconExtendedCell';
import TableGridTextExtendedCell from './tableGridTextExtendedCell/tableGridTextExtendedCell';

let componentModule = angular.module('app.components', [
  About.name,
  Login.name,
  Dashboard.name,
  DataBrowser.name,
  UserInfoPanel.name,
  TableComponent.name,
  TableGrid.name,
  TableGridRow.name,
  TableSearch.name,
  StatusIndicator.name,
  PaginationBar.name,
  UserAccount.name,
  SecureFileUploader.name,
  SyncSettings.name,
  Entitler.name,
  Assignments.name,
  AssignmentsUnassigned.name,
  ProductsSelector.name,
  SyncSchedule.name,
  EditCustomer.name,
  ConfigureCustomer.name,
  AddAdministrator.name,
  AgentDownloadLink.name,
  EditCustomerSection.name,
  ConfigureCustomer.name,
  RequestPasswordReset.name,
  PasswordReset.name,
  ErrorReport.name,
  DeactivateCustomerAdmin.name,
  SubmitSuccess.name,
  SecureAeriesConnection.name,
  TableGridTextCell.name,
  TableGridCheckboxCell.name,
  TableGridIconCell.name,
  TableGridValidationCell.name,
  TableGridRemoveCell.name,
  TableGridRadioCell.name,
  TableGridDropdownCell.name,
  CreateCustomer.name,
  Onboarding.name,
  AssignmentConfirmation.name,
  RunExport.name,
  SecureOneRosterApiConnection.name,
  UploadHistory.name,
  TableGridAccordionToggleCell.name,
  TableGridErrorReportCell.name,
  TableGridAccordionRow.name,
  SourceTable.name,
  TableGridBody.name,
  BatchErrors.name,
  TableGridModalLinkCell.name,
  SourceErrorsModal.name,
  ProxyingCustomerInfoPanel.name,
  SecureFileUploaderStepIndicator.name,
  SecureFileUploaderUploadStage.name,
  SecureFileUploaderValidateError.name,
  SecureFileUploaderCompleteStage.name,
  CustomerIntegrationInput.name,
  RadialProgressBar.name,
  AdminCreateSection.name,
  AddAlertMessage.name,
  uploadSettings.name,
  PurchasingAccounts.name,
  AdminToolSection.name,
  AdminPermissions.name,
  batchCancel.name,
  TableGridIconExtendedCell.name,
  TableGridTextExtendedCell.name
]);

export
default componentModule;



// WEBPACK FOOTER //
// ./app/components/components.js